import classNames from 'classnames/bind';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckSquare } from '@fortawesome/pro-solid-svg-icons/faCheckSquare';
import { faSquare } from '@fortawesome/pro-light-svg-icons/faSquare';

import withComponentName from '../../../../../../decorators/withComponentName';

import YearDropdown from './YearDropdown';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

const FilterInner = ({
  options, isSelectAll, handleSelectAll, handleOptionSelect,
  fromYear, toYear, isEsg, showUndated, handleShowUndatedSelect, isIR,
}) => (
  <div className={cx('filter_inner', { esg: isEsg, ir: isIR })}>
    <div className={Styles.filter_inner_title}>
      Year
    </div>
    <Dropdown.Item eventKey="all_value" active={isSelectAll} onSelect={handleSelectAll}>
      <FontAwesomeIcon icon={isSelectAll ? faCheckSquare : faSquare} />
      <div className={Styles.row_title}>All Years</div>
    </Dropdown.Item>
    <YearDropdown
      type="from"
      options={options}
      selectedValue={fromYear}
      handleOptionSelect={handleOptionSelect}
      isSelectAll={isSelectAll}
      maxValue={toYear}
    />
    <YearDropdown
      type="to"
      options={options}
      selectedValue={toYear}
      handleOptionSelect={handleOptionSelect}
      isSelectAll={isSelectAll}
      minValue={fromYear}
    />
    {isEsg && (
      <Dropdown.Item
        bsPrefix={cx('dropdown-item', { undated: true })}
        eventKey="show_undated_value"
        active={showUndated}
        onSelect={handleShowUndatedSelect}
      >
        <FontAwesomeIcon icon={showUndated ? faCheckSquare : faSquare} />
        <div className={Styles.row_show_title}>Include undated content</div>
      </Dropdown.Item>
    )}
  </div>
);

export default withComponentName(FilterInner);
